// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kSPQP","list":"styles_list__YtAq5","listWrapper":"styles_listWrapper__388Od","box":"styles_box__n6sCC"};